import React from 'react';
import Navigation from '../components/Navigation';
import SnowflakesEffect from '../components/SnowflakesEffect';
import { isChristmasPeriod } from '../utils/christmasTheme';
import '../styles/AboutPage.css';
import '../styles/christmas.css';

const AboutPage: React.FC = () => {
  const isChristmas = isChristmasPeriod();
  
  return (
    <div className={`about-page ${isChristmas ? 'christmas' : ''}`}>
      {isChristmas && <SnowflakesEffect />}
      {isChristmas && <div className="christmas-overlay" />}
      <Navigation />
      <div className="page-content">
        <div className="content-container">
          <h1 className="page-title">About ThanksBeer</h1>
          <div className="about-section">
            <p className="about-text">
              ThanksBeer is a fun and simple way to show appreciation to friends, colleagues, 
              and loved ones by sending them a virtual beer. In today's digital world, sometimes 
              a simple gesture can make someone's day.
            </p>
            <p className="about-text">
              Whether you want to say thanks for a favor, celebrate a win, or just brighten 
              someone's day, ThanksBeer makes it easy and instant.
            </p>
            <h2 className="section-heading">Our Mission</h2>
            <p className="about-text">
              To bring people together through simple acts of appreciation, one digital beer at a time.
            </p>
            <h2 className="section-heading">Why ThanksBeer?</h2>
            <ul className="feature-list">
              <li>🍺 Instant gratification - send a beer in seconds</li>
              <li>🎁 No cost, just pure appreciation</li>
              <li>🌍 Send anywhere, anytime</li>
              <li>😊 Spread joy and gratitude effortlessly</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
